import { ActivatedRouteSnapshot } from '@angular/router';
import { WAVE1B_SHELLS } from 'app/shared/wave1b-shell/wave1b-shell.definitions';

const ROUTE_SEGMENT_TITLES: Record<string, string> = {
    dashboard: 'Dashboard',
    admin: 'Tenant admin',
    store: 'Store',
};

export function resolveLayoutModuleTitle(route: ActivatedRouteSnapshot | null, url: string): string | null {
    const normalizedUrl = (url.split('?')[0].replace(/\/$/, '') || '/');

    if (normalizedUrl === '/dashboard/store' || normalizedUrl.startsWith('/dashboard/store/')) {
        return 'Dashboard';
    }

    let current = route;
    while (current) {
        const moduleCode = current.data['module'] as string | undefined;
        if (moduleCode) {
            return WAVE1B_SHELLS[moduleCode]?.title ?? titleCase(moduleCode);
        }
        current = current.parent;
    }

    const segment = url.split('?')[0].split('/').filter(Boolean)[0];
    if (segment && ROUTE_SEGMENT_TITLES[segment]) {
        return ROUTE_SEGMENT_TITLES[segment];
    }

    return null;
}

function titleCase(value: string): string {
    return value
        .split(/[-_]/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
}
